import { render, staticRenderFns } from "./ProductWindow.vue?vue&type=template&id=66e60616&scoped=true"
import script from "./ProductWindow.vue?vue&type=script&lang=js"
export * from "./ProductWindow.vue?vue&type=script&lang=js"
import style0 from "./ProductWindow.vue?vue&type=style&index=0&id=66e60616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e60616",
  null
  
)

export default component.exports